import React, { useState, useEffect, useRef } from "react";
import FilmWrapper from "../components/FilmWrapper";
import FotoWrapper from "../components/FotoWrapper";

export default function SwitchComponents() {
  const [activeComponent, setActiveComponent] = useState("film");
  const [category, setActiveCategory] = useState("Film");
  const [toggled, setToggled] = useState(false);
  const sliderWrapperRef = useRef(null);
  const filmSlideRef = useRef(null);
  const fotoSlideRef = useRef(null);

  // Button text and link based on the active component
  const buttonText = activeComponent === "film" ? "Filmprojekte" : "Fotoprojekte";
  const buttonLink = activeComponent === "film" ? "/film" : "/foto";

  // Function to update the slider wrapper height
  const updateSliderHeight = () => {
    if (sliderWrapperRef.current && filmSlideRef.current && fotoSlideRef.current) {
      const filmHeight = filmSlideRef.current.offsetHeight;
      const fotoHeight = fotoSlideRef.current.offsetHeight;
      const maxHeight = Math.max(filmHeight, fotoHeight);
      sliderWrapperRef.current.style.height = `${maxHeight}px`;
    }
  };

  // Update the slider height whenever the active component changes
  useEffect(() => {
    updateSliderHeight();
  }, [activeComponent]);

  // Update the slider height on window resize (optional)
  useEffect(() => {
    window.addEventListener("resize", updateSliderHeight);
    return () => window.removeEventListener("resize", updateSliderHeight);
  }, []);

  function toggleHandler() {
    setToggled(!toggled);
    if (activeComponent === "film") {
      setActiveComponent("foto");
      setActiveCategory("Foto");
    } else {
      setActiveComponent("film");
      setActiveCategory("Film");
    }
  }

  return (
    <>
      {/* Toggle Button */}
      <button
        className={`toggle-btn ${toggled ? "toggled" : ""}`}
        onClick={toggleHandler}
      >
        <span className="category-text bodycopy left">Film</span>
        <span className="category-text bodycopy right">Foto</span>
        <div className="thumb">
          <div className="bodycopy">{category}</div>
        </div>
      </button>

      {/* Slider Wrapper */}
      <div className="slider-wrapper" ref={sliderWrapperRef}>
        <div
          className={
            activeComponent === "film" ? "slide-center" : "slide-left"
          }
          ref={filmSlideRef}
        >
          <FilmWrapper />
        </div>
        <div
          className={
            activeComponent === "foto" ? "slide-center" : "slide-right"
          }
          ref={fotoSlideRef}
        >
          <FotoWrapper />
        </div>
      </div>

      {/* Dynamic Button */}
      <a href={buttonLink} className="button-primary h4" style={{ alignSelf: "start", textDecoration: "none" }}>
        {buttonText}
      </a>
    </>
  );
}